<template>
  <v-container class='noPadding'>
    <v-row>
      <v-col cols='12' class='offset-xs0 offset-sm0 offset-md-9 col-md-1 col-sm-4 col-xs-4'>
        <v-speed-dial
          v-model='fabTool'
          :top='true'
          :bottom='false'
          :right='true'
          :left='false'
          :direction="'bottom'"
          :open-on-hover='false'
          :transition="'slide-y-reverse-transition'"
          class='speedDial2'>
          <template v-slot:activator>
            <v-btn
              v-model='fabTool'
              :color='settings.color'
              dark fab>
              <v-icon v-if='fabTool'>mdi-close</v-icon>
              <v-icon v-else>{{whiteboardLib && whiteboardLib.toolStack.getIconForTool(settings.tool)}}</v-icon>
            </v-btn>
          </template>
          <v-btn fab dark small :color='settings.color' @click="selectTool('toolPath')"><v-icon>mdi-pencil</v-icon></v-btn>
          <v-btn fab dark small :color='settings.color' @click="selectTool('delete')"><v-icon>mdi-eraser</v-icon></v-btn>
          <v-btn fab dark small :color='settings.color' @click="selectTool('toolMark')"><v-icon>mdi-cursor-pointer</v-icon></v-btn>
        </v-speed-dial>
      </v-col>
      <v-col cols='12' class='col-md-1 col-sm-4 col-xs-4'>
        <v-speed-dial
          v-model='fabColor'
          :top='true'
          :bottom='false'
          :right='true'
          :left='false'
          :direction="'bottom'"
          :open-on-hover='false'
          :transition="'slide-y-reverse-transition'">
          <template v-slot:activator>
            <v-btn v-model='fabColor' :color='settings.color' dark fab>
              <v-icon v-if='fabColor'>mdi-close</v-icon>
              <v-icon v-else>mdi-palette</v-icon>
            </v-btn>
          </template>
          <v-btn fab dark small color='green' @click='settings.color="green"'><v-icon>mdi-palette</v-icon></v-btn>
          <v-btn fab dark small color='indigo' @click='settings.color="indigo"'><v-icon>mdi-palette</v-icon></v-btn>
          <v-btn fab dark small color='red' @click='settings.color="red"'><v-icon>mdi-palette</v-icon></v-btn>
        </v-speed-dial>
      </v-col>
      <v-col cols='12' class='col-md-1 col-sm-4 col-xs-4'>
        <v-speed-dial
          v-model='fabLine'
          :top='true'
          :bottom='false'
          :right='true'
          :left='false'
          :direction="'bottom'"
          :open-on-hover='false'
          :transition="'slide-y-reverse-transition'"
          class='speedDial3'>
          <template v-slot:activator>
            <v-btn v-model='fabLine' :color='settings.color' dark fab>
              <v-badge color='blue' overlap :content='settings.line'>
                <v-icon v-if='fabLine'>mdi-close</v-icon>
                <v-icon v-else>mdi-format-line-weight</v-icon>
              </v-badge>
            </v-btn>
          </template>
          <v-btn fab dark small :color='settings.color' @click='selectLine(1)'>1</v-btn>
          <v-btn fab dark small :color='settings.color' @click='selectLine(2)'>2</v-btn>
          <v-btn fab dark small :color='settings.color' @click='selectLine(3)'>3</v-btn>
        </v-speed-dial>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols='12' class='col-md-12 whitebackground'>
        <v-card>
          <canvas id='myCanvas' ref='myCanvas' style='' resize/>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { WhiteboardLib } from '@/libs/whiteboardLib';

export default {
  name: 'InkNote',
  props: ['value'],
  watch: {
    value() {
      if (this.WhiteboardLib !== null) {
        try {
          if (!this.value.html || this.value.html === '') {
            this.whiteboardLib.clearProject();
            return
          }
          const json = JSON.parse(this.value.html)
          this.whiteboardLib.importJSON(json);
        } catch (e) {}
      }
    }
  },
  data: () => ({
    fabColor: false,
    fabTool: false,
    fabLine: false,
    whiteboardLib: null,
    settings: {
      color: 'red',
      tool: 'toolPath',
      line: 2,
    },
    toolPointer: null
  }),
  methods: {
    selectTool(tool) {
      this.settings.tool = tool;
      // eslint-disable-next-line no-unused-expressions
      this.whiteboardLib?.toolStack.activateTool(tool);
    },
    selectLine(line) {
      this.settings.line = line
    },
    onChanged() {
      const self = this;
      setTimeout(() => {
        const json = self.whiteboardLib?.exportJSON();
        self.value.html = JSON.stringify(json)
        self.value.image = self.$refs.myCanvas.toDataURL('image/png')
        self.value.modified = true;
        self.$emit('onChanged', self.value.html)
      }, 100)
    }
  },
  mounted() {
    const self = this;
    this.whiteboardLib = new WhiteboardLib(this.settings, this.$refs.myCanvas, { onModified: self.onChanged })
    if (this.value.html) this.whiteboardLib.importJSON(JSON.parse(this.value.html))
  }
}
</script>

<style scoped>
  canvas[resize] {
    width: 100%;
    height: 90vh;
    display: block;
    margin: auto;
    border: lightgray 1px dashed;
    background-color: white;
  }

  .speedDial2 {
    margin-right: 90px!important;
  }
  .speedDial3 {
    margin-right:167px!important;
  }

</style>
